import React, { forwardRef } from 'react';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';

const UiButton = forwardRef(
  ({ children, loading, textColor, ...restProps }, ref) => (
    <Button
      ref={ref}
      disableElevation
      variant='contained'
      color='primary'
      {...restProps}
    >
      <span style={textColor ? { color: textColor } : {}}>
        {children}
        {loading && (
          <CircularProgress
            size={24}
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              marginTop: '-12px',
              marginLeft: '-12px',
            }}
            color='primary'
          />
        )}
      </span>
    </Button>
  )
);

UiButton.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  textColor: PropTypes.string,
};

export default UiButton;
